<button *ngFor="let item of statusList"
        class="mat-menu-panel-btn"
        [class.active]="contextOptions.status === item.id"
        (click)="select($event, item.id)">
  <span [class]="'status-dot ' + item.iconCssClass"></span>
  <span>{{ item.name }}</span>
  <span class="suffix" *ngIf="item.nameSuffix">{{ item.nameSuffix }}</span>
</button>
